
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class APIKeysDialog extends Serenity.EntityDialog<APIKeysRow, any> {
        protected getFormKey() { return APIKeysForm.formKey; }
        protected getIdProperty() { return APIKeysRow.idProperty; }
        protected getLocalTextPrefix() { return APIKeysRow.localTextPrefix; }
        protected getNameProperty() { return APIKeysRow.nameProperty; }
        protected getService() { return APIKeysService.baseUrl; }
        protected getDeletePermission() { return APIKeysRow.deletePermission; }
        protected getInsertPermission() { return APIKeysRow.insertPermission; }
        protected getUpdatePermission() { return APIKeysRow.updatePermission; }

        protected form = new APIKeysForm(this.idPrefix);

        constructor() {
            super();
            
            this.form.Button.onClick = (e) => {
                this.GenerateSecret(e);
            };

            
        }

        afterLoadEntity() {
            super.afterLoadEntity();
            if (Q.isEmptyOrNull(this.entityId))
                this.form.ClientId.value = this.generateUUID();

        }
        private generateUUID(){
            let
                d = new Date().getUTCMilliseconds(),
                d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                let r = Math.random() * 16;
                if (d > 0) {
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                } else {
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16).toUpperCase();
            });
        };

        protected GenerateSecret(e: any): void {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < 16; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            this.form.Secret.value = result;


            //var encrypt = CryptoJS.AES.encrypt(this.form.ClientId.value, result);

            this.form.Key.value = this.encryptUsingAES256(result, this.form.ClientId.value).toString();

            
            //Administration.APIKeysService.GenerateAPIKey({
            //    AppName: this.form.AppName.value,
            //    ClientId: this.form.ClientId.value,
            //    Secret: this.form.Secret.value,
            //    Role: "Admin"

            //},
            //    response => this.form.ApiKey.value = response.Token,
            //    { async: false }
            //);
        }

       

        // Methods for the encrypt and decrypt Using AES
        encryptUsingAES256(secret: string, ClientId: string) {
            var key = CryptoJS.enc.Utf8.parse(secret);
            var iv = CryptoJS.enc.Utf8.parse(secret);

            var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ClientId), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            console.log('Encrypted :' + encrypted);
            return encrypted;
        }

            
    }
} 